import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EntityContextState {
	category: string;
	dateRange: string;
	program: string;
	region: string;
}

const initialState: EntityContextState = {
	category: "all",
	dateRange: "12m",
	program: "all",
	region: "national"
};

export const entityContextSlice = createSlice({
	initialState,
	name: "entityContext",
	reducers: {
		resetContext: () => {
			return initialState;
		},
		setCategory: (state, action: PayloadAction<string>) => {
			state.category = action.payload;
		},
		setDateRange: (state, action: PayloadAction<string>) => {
			state.dateRange = action.payload;
		},
		setProgram: (state, action: PayloadAction<string>) => {
			state.program = action.payload;
		},
		setRegion: (state, action: PayloadAction<string>) => {
			state.region = action.payload;
		}
	}
});

export const { resetContext, setCategory, setDateRange, setProgram, setRegion } = entityContextSlice.actions;

export default entityContextSlice.reducer;
